// extracted by mini-css-extract-plugin
export default {"Wrapper":"FieldComparison_Wrapper__oIPzG","CustomYTick":"FieldComparison_CustomYTick__qQkQN","TitleName":"FieldComparison_TitleName__oawGG"};